/**
 * The account area pages added by the locations rebuild (spec section 2.1):
 * Connected locations at /app/connections and Workspace settings at
 * /app/workspace.
 *
 * Spread inside appLocationRoutes() so App.tsx (past a thousand lines) gains
 * no line. The routes sit in App.tsx's FunnelBoundary group beside
 * /app/account, whose Suspense shows the app's colour while a chunk loads.
 *
 * Not wrapped in the per-location shell (the one in locations/):
 * it sends any route without a :locationId away. Like /app/account, each page calls useAppAccount, which
 * sends a signed-out visitor to sign in and back.
 */
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';

const AppConnectionsPage = lazy(() => import('./connections/AppConnectionsPage'));
const AppWorkspacePage = lazy(() => import('./workspace/AppWorkspacePage'));

/** The routes, for appLocationRoutes() to spread. */
export function appAreaRoutes(): ReactElement[] {
  return [
    <Route key="app:connections" path="/app/connections" element={<AppConnectionsPage />} />,
    <Route key="app:workspace" path="/app/workspace" element={<AppWorkspacePage />} />,
  ];
}
